import { memo } from "react";
import {
  Banner,
  BlockStack,
  Text,
} from "@shopify/ui-extensions-react/customer-account";
import { useSeatUploadBanner } from "../hooks/useSeatUploadBanner";
import { SeatUploadBannerProps } from "../types";

export const SeatUploadBanner = memo(({
  seatRequirements,
}: SeatUploadBannerProps) => {
  const {
    title,
    instructions,
    groupedRequirementsData,
    seatTypeInstructions,
    hasMultipleItems,
    multipleItemsNote,
  } = useSeatUploadBanner({ seatRequirements });

  return (
    <Banner status="info">
      <BlockStack spacing="tight" background="base">
        <Text emphasis="bold">{title}</Text>

        <Text>{instructions}</Text>

        <BlockStack spacing="extraTight">
          {groupedRequirementsData.map((req) => (
            <Text key={req.seatType} appearance="subdued" size="small">
              • {req.displayName}: {req.totalPhotosForType} photos
              {req.itemCount > 1 &&
                ` (${req.photosPerItem} photos × ${req.itemCount} items)`}
            </Text>
          ))}
        </BlockStack>

        <BlockStack spacing="extraTight">
          {seatTypeInstructions.map(({ seatType, instruction }) => (
            <Text
              key={`instruction-${seatType}`}
              appearance="subdued"
              size="small"
            >
              {instruction}
            </Text>
          ))}
        </BlockStack>

        {hasMultipleItems && (
          <Text appearance="subdued" size="small" emphasis="italic">
            {multipleItemsNote}
          </Text>
        )}
      </BlockStack>
    </Banner>
  );
});
